import { defineComponent as _defineComponent } from 'vue';
export default /*#__PURE__*/_defineComponent({
  __name: 'CustomImpactSolutionResults',
  props: {
    impactSolution: null,
    evidenceLinks: null
  },
  setup: function setup(__props) {
    var props = __props;

    /** Open evidence by default (Vuetify panel index). */
    var evidencePanel = ref(0);
    var solutionTitle = computed(function () {
      var _props$impactSolution, _props$impactSolution2;
      return ((_props$impactSolution = props.impactSolution) === null || _props$impactSolution === void 0 ? void 0 : (_props$impactSolution2 = _props$impactSolution.concept) === null || _props$impactSolution2 === void 0 ? void 0 : _props$impactSolution2.label) || 'Solution';
    });
    var solutionDescription = computed(function () {
      var _props$impactSolution3;
      return ((_props$impactSolution3 = props.impactSolution) === null || _props$impactSolution3 === void 0 ? void 0 : _props$impactSolution3.solutionDescription) || '';
    });
    var problemDescription = computed(function () {
      var _props$impactSolution4;
      return ((_props$impactSolution4 = props.impactSolution) === null || _props$impactSolution4 === void 0 ? void 0 : _props$impactSolution4.problemDescription) || '';
    });
    var targetGroup = computed(function () {
      var _props$impactSolution5;
      return ((_props$impactSolution5 = props.impactSolution) === null || _props$impactSolution5 === void 0 ? void 0 : _props$impactSolution5.targetGroup) || '';
    });
    return {
      __sfc: true,
      props: props,
      evidencePanel: evidencePanel,
      solutionTitle: solutionTitle,
      solutionDescription: solutionDescription,
      problemDescription: problemDescription,
      targetGroup: targetGroup
    };
  }
});